import { Component, Input } from '@angular/core';

import { ClaimWithCase } from 'src/app/core/services/claims.service';

@Component({
  selector: 'app-os-actions-lst',
  templateUrl: './os-actions-lst.component.html',
  styleUrls: ['./os-actions-lst.component.scss'],
})
export class OsActionsLstComponent {
  @Input() claims?: ClaimWithCase[] | null;

  onSlideChange(event: any) {
    console.log('slide changed', event);
  }
}
